"use strict";

let userId = "";
let privateKeyPem = "";
let tenantId = "";
let userName = "";
let userAvatarUrl = "";
let mapKey = "";

// Async version of setAuthContext
export async function setAuthContext(config) {
  return new Promise(resolve => {
    userId = config.userId || "";
    privateKeyPem = config.privateKeyPem || "";
    tenantId = config.tenantId || "";
    userName = config.userName || "";
    userAvatarUrl = config.userAvatarUrl || "";
    mapKey = config.mapKey || "";
    resolve(); // Complete the Promise
  });
}

// Async version of getAuthContext
export function getAuthContext() {
  if (!userId || !privateKeyPem || !tenantId) {
    console.error("Auth context is not set. Please call setAuthContext() first.");
  }
  return {
    userId,
    privateKeyPem,
    tenantId,
    userName,
    userAvatarUrl,
    mapKey
  };
}
//# sourceMappingURL=authConfig.js.map